const ErrorException = (err) => {
    if (err.response) {
        // eslint-disable-next-line
        if (typeof err.response.data.errors.length === 0) {
            return "There was an error checking your connection or input";
        }
        if (typeof err.response.data.errors[0].message === 'string') {
            return err.response.data.errors[0].message;
        }
        return err.response.data.errors[0].message.name;

    } if (err.message) {
        return err.message;
    }

    return "There was an error checking your connection or input";
};

export default ErrorException;
